module.exports = __webpack_public_path__ + "img/logo1.38547c4d.png";